// export function processRecipes(tasks) {
//   // Step 1: Split tasks based on 'cookIn' property
//   const recipe1 = tasks.filter((task) => task.cookIn === "np1");
//   const recipe2 = tasks.filter((task) => task.cookIn === "np2");

import { WAITING_RECIPE_DURATION } from "../constants";

//   console.log("recipe1", recipe1);
//   console.log("recipe2", recipe2);

//   // Helper function to calculate times
//   function calculateTimes(recipe) {
//     let cookTime = recipe
//       .filter((task) => task.category === "Waiting Action")
//       .reduce((sum, task) => sum + task.duration, 0);
//     let prepTime = recipe
//       .filter((task) => task.category !== "Waiting Action")
//       .reduce((sum, task) => sum + task.duration, 0);
//     return { cookTime, prepTime };
//   }

//   let times1 = calculateTimes(recipe1);
//   let times2 = calculateTimes(recipe2);

//   console.log("times1", times1);
//   console.log("times2", times2);

//   let primaryRecipe = times1.cookTime > times2.cookTime ? recipe1 : recipe2;
//   let secondaryRecipe = times1.cookTime > times2.cookTime ? recipe2 : recipe1;

//   console.log("primaryRecipe", primaryRecipe);
//   console.log("secondaryRecipe", secondaryRecipe);

//   let mergedTasks = [];
//   let pendingTasks = [];
//   let waitingCounter = 0;
//   let chimneyOnUsed = false;

//   function addTask(task) {
//     if (task.name === "Chimney On") {
//       if (!chimneyOnUsed) {
//         mergedTasks.push(task);
//         chimneyOnUsed = true;
//       }
//     } else {
//       mergedTasks.push(task);
//     }
//   }

//   function processRecipe(recipe) {
//     for (let task of recipe) {
//       if (task.category === "Waiting Action" && task.duration > 300) {
//         waitingCounter = task.duration;
//         pendingTasks.push(...recipe.slice(recipe.indexOf(task)));
//         break;
//       }
//       addTask(task);
//     }
//   }

//   processRecipe(primaryRecipe);

//   for (let task of secondaryRecipe) {
//     if (task.name === "Chimney On") continue; // Skip additional Chimney On
//     if (task.category === "Waiting Action") {
//       if (waitingCounter > task.duration) {
//         waitingCounter -= task.duration;
//         addTask(task);
//       } else {
//         pendingTasks.push(task);
//         break;
//       }
//     } else {
//       addTask(task);
//     }
//   }

//   function updatePendingTaskCookTime(pendingTasksList, alreadyMergedTasks) {
//     for (let task of pendingTasksList) {
//       if (task.category === "Waiting Action") {
//         console.log("task", task);
//         console.log("waitingCounter", waitingCounter);
//         task.duration = waitingCounter;
//         break;
//       }
//     }

//     // Remove "chimeny off" from alreadyMergedTasks if present in both lists
//     if (
//       pendingTasksList.some((task) => task.name === "Chimney Off") &&
//       alreadyMergedTasks.some((task) => task.name === "Chimney Off")
//     ) {
//       return (mergedTasks = alreadyMergedTasks.filter(
//         (task) => task.name !== "Chimney Off"
//       ));
//     }
//   }

//   updatePendingTaskCookTime(pendingTasks, mergedTasks);

//   function spreadMergedTasksAndPendingTasks(beforeMergedTasks, pendingTasks) {
//     return (mergedTasks = [...beforeMergedTasks, ...pendingTasks]);
//   }

//   spreadMergedTasksAndPendingTasks(mergedTasks, pendingTasks);

//   // if (chimneyOnUsed) {
//   //     mergedTasks.push({ name: 'Chimney Off' });
//   // }

//   function chimneyOff(mergedTasks) {
//     // Check if "Chimney Off" is already present
//     const isChimneyOffPresent = mergedTasks.some(
//       (task) => task.name === "Chimney Off"
//     );

//     if (!isChimneyOffPresent) {
//       // Add "Chimney Off" only if chimneyOnUsed is true
//       if (chimneyOnUsed) {
//         mergedTasks.push({
//           category: "Chimney Action",
//           code: "await chimny(0);",
//           complete: 0,
//           cookIn: "np1",
//           duration: 15,
//           errorMessage: "",
//           function: "",
//           id: "1738762419439",
//           isOk: false,
//           level: 0,
//           name: "Chimney Off",
//           type: "none",
//           valid: true,
//         });
//         chimneyOnUsed = false; // Reset flag
//       }
//     }
//   }

//   chimneyOff(mergedTasks);

//   console.log("mergedTasks", mergedTasks);
//   console.log("pendingTasks", pendingTasks);
//   console.log("waitingCounter", waitingCounter);
//   console.log("chimneyOnUsed", chimneyOnUsed);

//   return { mergedTasks };
// }

// export function mergeRecipes(tasks) {
//   const np1Recipe = tasks.filter((item) => item.cookIn === "np1");
//   const np2Recipe = tasks.filter((item) => item.cookIn === "np2");

//   console.log("np1Recipe", np1Recipe);
//   console.log("np2Recipe", np2Recipe);

//   function calculateTimes(recipe) {
//     let cookTime = recipe
//       .filter((task) => task.category === "Waiting Action")
//       .reduce((sum, task) => sum + task.duration, 0);
//     let prepTime = recipe
//       .filter((task) => task.category !== "Waiting Action")
//       .reduce((sum, task) => sum + task.duration, 0);
//     return { cookTime, prepTime };
//   }

//   let np1RecipeTime = calculateTimes(np1Recipe);
//   let np2RecipeTime = calculateTimes(np2Recipe);

//   console.log("np1RecipeTime", np1RecipeTime);
//   console.log("np2RecipeTime", np2RecipeTime);

//   let primaryRecipe =
//     np1RecipeTime.cookTime > np2RecipeTime.cookTime ? np1Recipe : np2Recipe;
//   let secondaryRecipe =
//     np1RecipeTime.cookTime > np2RecipeTime.cookTime ? np2Recipe : np1Recipe;

//   console.log("primaryRecipe", primaryRecipe);
//   console.log("secondaryRecipe", secondaryRecipe);

//   // Step 1: Split primary recipe before and after waiting action
//   const waitingIndex = primaryRecipe.findIndex(
//     (task) => task.category === "Waiting Action"
//   );
//   const beforeWaitingActions = primaryRecipe.slice(0, waitingIndex);
//   const waitingAction = primaryRecipe[waitingIndex];
//   const afterWaitingActions = primaryRecipe.slice(waitingIndex + 1);

//   // Step 2: Extract secondary recipe tasks
//   let remainingSecondaryTasks = [...secondaryRecipe];
//   let mergedTasks = [...beforeWaitingActions];
//   let waitingTime = waitingAction.duration; // Initial waiting time

//   // Step 3: Add secondary tasks within waiting time limit
//   while (remainingSecondaryTasks.length > 0) {
//     const nextTask = remainingSecondaryTasks[0];

//     if (nextTask.duration <= waitingTime) {
//       mergedTasks.push(remainingSecondaryTasks.shift());
//       waitingTime -= nextTask.duration;
//     } else {
//       break;
//     }
//   }

//   console.log("afterWaitingActions", afterWaitingActions);
//   console.log("remainingSecondaryTasks", remainingSecondaryTasks);

//   // Step 4: Update waiting action time
//   if (waitingTime > 0) {
//     waitingAction.duration = waitingTime;
//     mergedTasks.push(waitingAction);
//     mergedTasks.push(...afterWaitingActions);
//   } else {
//     mergedTasks.push(...afterWaitingActions);
//   }

//   // Step 5: Append remaining secondary tasks
//   mergedTasks.push(...remainingSecondaryTasks);

//   return mergedTasks;
// }

// export function mergeRecipes(tasks) {
//   console.log("mergeRecipes", tasks);
//   try {
//     if (!Array.isArray(tasks) || tasks.length === 0) {
//       throw new Error("No tasks provided for merging");
//     }

//     let initialRecipe = tasks.filter(
//       (task) => task.name !== "Chimney On" && task.name !== "Chimney Off"
//     );

//     const np1Recipe = initialRecipe.filter((item) => item.cookIn === "np1");
//     const np2Recipe = initialRecipe.filter((item) => item.cookIn === "np2");

//     // Validate if we have tasks for at least one pot
//     if (np1Recipe.length === 0 && np2Recipe.length === 0) {
//       throw new Error("No valid tasks found for either NutriPot");
//     }

//     const isHeatOnForNP1 = np1Recipe.find(
//       (item) => item.name === "Heat On" && item.cookIn === "np1"
//     );
//     const isHeatOffForNP1 = np1Recipe.find(
//       (item) => item.name === "Heat Off" && item.cookIn === "np1"
//     );
//     const isHeatOnForNP2 = np2Recipe.find(
//       (item) => item.name === "Heat On" && item.cookIn === "np2"
//     );
//     const isHeatOffForNP2 = np2Recipe.find(
//       (item) => item.name === "Heat Off" && item.cookIn === "np2"
//     );

//     if (isHeatOnForNP1 && !isHeatOffForNP1) {
//       np1Recipe.push({
//         id: Date.now().toString(),
//         name: "Heat Off",
//         duration: 1,
//         valid: true,
//         complete: 0,
//         category: "Nutripot Action",
//         function: "",
//         type: "none",
//         cookIn: "np1",
//         level: "off",
//         code: "await setHeat('off',this.utensil);",
//         errorMessage: "",
//         isOk: false,
//       });
//     }

//     if (isHeatOnForNP2 && !isHeatOffForNP2) {
//       np2Recipe.push({
//         id: Date.now().toString(),
//         name: "Heat Off",
//         duration: 1,
//         valid: true,
//         complete: 0,
//         category: "Nutripot Action",
//         function: "",
//         type: "none",
//         cookIn: "np2",
//         level: "off",
//         code: "await setHeat('off',this.utensil);",
//         errorMessage: "",
//         isOk: false,
//       });
//     }

//     function calculateTimes(recipe) {
//       let cookTime = recipe
//         .filter((task) => task.category === "Waiting Action")
//         .reduce((sum, task) => sum + task.duration, 0);
//       let prepTime = recipe
//         .filter((task) => task.category !== "Waiting Action")
//         .reduce((sum, task) => sum + task.duration, 0);
//       return { cookTime, prepTime };
//     }

//     let np1RecipeTime = calculateTimes(np1Recipe);
//     let np2RecipeTime = calculateTimes(np2Recipe);

//     const chimenyOnTask = {
//       id: Date.now().toString(),
//       name: "Chimney On",
//       duration: 15,
//       valid: true,
//       complete: 0,
//       category: "Chimney Action",
//       function: "",
//       type: "none",
//       cookIn: "np1",
//       level: 1,
//       code: "await chimny(1);",
//       errorMessage: "",
//       isOk: false,
//     };
//     const chimenyOffTask = {
//       id: Date.now().toString(),
//       name: "Chimney Off",
//       duration: 15,
//       valid: true,
//       complete: 0,
//       category: "Chimney Action",
//       function: "",
//       type: "none",
//       cookIn: "np1",
//       level: 0,
//       code: "await chimny(0);",
//       errorMessage: "",
//       isOk: false,
//     };

//     let primaryRecipe =
//       np1RecipeTime.cookTime > np2RecipeTime.cookTime ? np1Recipe : np2Recipe;
//     let secondaryRecipe =
//       np1RecipeTime.cookTime > np2RecipeTime.cookTime ? np2Recipe : np1Recipe;

//     primaryRecipe.unshift(chimenyOnTask);
//     secondaryRecipe.push(chimenyOffTask);

//     np1RecipeTime = calculateTimes(
//       np1RecipeTime.cookTime > np2RecipeTime.cookTime ? np1Recipe : np2Recipe
//     );
//     np2RecipeTime = calculateTimes(
//       np1RecipeTime.cookTime > np2RecipeTime.cookTime ? np2Recipe : np1Recipe
//     );

//     // Early return if secondary recipe is empty
//     if (secondaryRecipe.length === 0) {
//       primaryRecipe.unshift(chimenyOnTask);
//       primaryRecipe.push(chimenyOffTask);
//       return primaryRecipe;
//     }

//     // Early return if primary recipe is empty
//     if (primaryRecipe.length === 0) {
//       secondaryRecipe.unshift(chimenyOnTask);
//       secondaryRecipe.push(chimenyOffTask);
//       return secondaryRecipe;
//     }

//     // Find waiting action with validation
//     const waitingIndex = primaryRecipe.findIndex(
//       (task) => task?.category === "Waiting Action"
//     );

//     if (waitingIndex === -1) {
//       throw new Error("No waiting action found in primary recipe");
//     }

//     const beforeWaitingActions = primaryRecipe.slice(0, waitingIndex);
//     const waitingAction = primaryRecipe[waitingIndex];

//     if (!waitingAction?.duration) {
//       throw new Error("Waiting action has no duration");
//     }

//     const afterWaitingActions = primaryRecipe.slice(waitingIndex + 1);

//     // Extract secondary recipe tasks with validation
//     let remainingSecondaryTasks = [...secondaryRecipe].filter(
//       (task) => task && typeof task === "object"
//     );
//     let mergedTasks = [...beforeWaitingActions];
//     let waitingTime = waitingAction.duration;

//     // Add secondary tasks with duration validation
//     while (remainingSecondaryTasks.length > 0) {
//       const nextTask = remainingSecondaryTasks[0];
//       if (!nextTask?.duration) {
//         remainingSecondaryTasks.shift(); // Remove invalid task
//         continue;
//       }

//       if (nextTask.duration <= waitingTime) {
//         mergedTasks.push(remainingSecondaryTasks.shift());
//         waitingTime -= nextTask.duration;
//       } else {
//         break;
//       }
//     }

//     // Update waiting action time
//     if (waitingTime > 0) {
//       waitingAction.duration = waitingTime;
//       mergedTasks.push(waitingAction);
//       mergedTasks.push(...afterWaitingActions);
//     } else {
//       mergedTasks.push(...afterWaitingActions);
//     }

//     // Handle remaining secondary tasks with validation
//     if (remainingSecondaryTasks.length > 0) {
//       const waitingIndex = remainingSecondaryTasks.findIndex(
//         (task) => task?.category === "Waiting Action"
//       );

//       if (waitingIndex !== -1 && remainingSecondaryTasks[waitingIndex]) {
//         const afterWaitingActionsTotalDuration = afterWaitingActions.reduce(
//           (sum, task) => sum + (task?.duration || 0),
//           0
//         );

//         if (
//           typeof remainingSecondaryTasks[waitingIndex].duration === "number"
//         ) {
//           remainingSecondaryTasks[waitingIndex].duration = Math.max(
//             remainingSecondaryTasks[waitingIndex].duration -
//               afterWaitingActionsTotalDuration -
//               waitingAction.duration,
//             0
//           );

//           // Calculate total before duration only if we have valid tasks
//           const totalBeforeDuration = remainingSecondaryTasks
//             .slice(0, waitingIndex)
//             .reduce((sum, task) => sum + (task?.duration || 0), 0);

//           remainingSecondaryTasks[waitingIndex].duration = Math.max(
//             remainingSecondaryTasks[waitingIndex].duration -
//               totalBeforeDuration,
//             0
//           );
//         }
//       }
//     }

//     // Append remaining tasks after validation
//     mergedTasks.push(
//       ...remainingSecondaryTasks.filter(
//         (task) => task && typeof task === "object"
//       )
//     );

//     return mergedTasks;
//   } catch (error) {
//     console.error("Error in mergeRecipes:", error);
//     throw error;
//   }
// }

//by pankaj
// export function mergeRecipes(tasks) {
//   console.log("Starting recipe merge with tasks:", tasks);
//   try {
//     // Validate input
//     if (!Array.isArray(tasks) || tasks.length === 0) {
//       throw new Error("Invalid input: Tasks array is empty or not an array");
//     }

//     // Clean initial recipe
//     const initialRecipe = tasks.filter(
//       (task) =>
//         task &&
//         typeof task === "object" &&
//         task.name &&
//         typeof task.duration === "number" &&
//         task.name !== "Chimney On" &&
//         task.name !== "Chimney Off"
//     );

//     // Split into NP1 and NP2 recipes
//     const np1Recipe = initialRecipe.filter(
//       (item) => item.cookIn === "np1" && typeof item.duration === "number"
//     );
//     const np2Recipe = initialRecipe.filter(
//       (item) => item.cookIn === "np2" && typeof item.duration === "number"
//     );

//     // Validate we have at least one valid recipe
//     if (np1Recipe.length === 0 && np2Recipe.length === 0) {
//       console.warn("No valid tasks found for either NutriPot");
//       return [];
//     }

//     // Helper function to calculate times
//     const calculateTimes = (recipe) => ({
//       cookTime: recipe.reduce(
//         (sum, task) =>
//           task.category === "Waiting Action" ? sum + task.duration : sum,
//         0
//       ),
//       prepTime: recipe.reduce(
//         (sum, task) =>
//           task.category !== "Waiting Action" ? sum + task.duration : sum,
//         0
//       ),
//     });

//     // Determine primary and secondary recipes
//     const getTotalTime = (recipe) =>
//       calculateTimes(recipe).cookTime + calculateTimes(recipe).prepTime;

//     const np1Time = getTotalTime(np1Recipe);
//     const np2Time = getTotalTime(np2Recipe);

//     const [primaryRecipe, secondaryRecipe] =
//       np1Time >= np2Time ? [np1Recipe, np2Recipe] : [np2Recipe, np1Recipe];

//     // Create chimney tasks
//     const chimneyBase = {
//       valid: true,
//       complete: 0,
//       errorMessage: "",
//       isOk: false,
//     };

//     const chimneyOnTask = {
//       ...chimneyBase,
//       id: `chimney_on_${Date.now()}`,
//       name: "Chimney On",
//       duration: 15,
//       category: "Chimney Action",
//       code: "await chimny(1);",
//       cookIn: primaryRecipe[0]?.cookIn || "np1",
//     };

//     const chimneyOffTask = {
//       ...chimneyBase,
//       id: `chimney_off_${Date.now()}`,
//       name: "Chimney Off",
//       duration: 15,
//       category: "Chimney Action",
//       code: "await chimny(0);",
//       cookIn: secondaryRecipe[0]?.cookIn || primaryRecipe[0]?.cookIn || "",
//     };

//     // Find first valid waiting action
//     const waitingIndex = primaryRecipe.findIndex(
//       (task) => task?.category === "Waiting Action"
//     );

//     let mergedTasks = [];

//     if (waitingIndex !== -1) {
//       // Split around waiting action
//       const beforeWait = primaryRecipe.slice(0, waitingIndex);
//       const waitingAction = primaryRecipe[waitingIndex];
//       const afterWait = primaryRecipe.slice(waitingIndex + 1);

//       let remainingTime = waitingAction.duration;
//       const validSecondary = secondaryRecipe.filter(
//         (task) => task && typeof task.duration === "number"
//       );

//       // Merge compatible tasks
//       mergedTasks = [...beforeWait];
//       for (const task of validSecondary) {
//         if (task.duration <= remainingTime) {
//           mergedTasks.push(task);
//           remainingTime -= task.duration;
//         } else {
//           break;
//         }
//       }

//       // Update waiting action duration
//       if (remainingTime > 0) {
//         mergedTasks.push({ ...waitingAction, duration: remainingTime });
//       }
//       mergedTasks.push(...afterWait);

//       // Add remaining secondary tasks
//       mergedTasks.push(
//         ...validSecondary.slice(mergedTasks.length - beforeWait.length)
//       );
//     } else {
//       // No waiting action - sequential merge
//       mergedTasks = [
//         ...primaryRecipe,
//         ...secondaryRecipe.filter(
//           (task) => task.name !== "Chimney On" && task.name !== "Chimney Off"
//         ),
//       ];
//     }

//     // Add chimney tasks if missing
//     if (!mergedTasks.some((t) => t.name === "Chimney On")) {
//       mergedTasks = [chimneyOnTask, ...mergedTasks];
//     }
//     if (!mergedTasks.some((t) => t.name === "Chimney Off")) {
//       mergedTasks.push(chimneyOffTask);
//     }

//     // Final validation and cleanup
//     const finalMergedTasks = mergedTasks
//       .filter(
//         (task) =>
//           task &&
//           typeof task === "object" &&
//           typeof task.duration === "number" &&
//           typeof task.name === "string"
//       )
//       .map((task, index) => ({
//         ...task,
//         id: task.id || `merged_task_${Date.now()}_${index}`,
//       }));
//     console.log("finalMergedTasks", finalMergedTasks);
//     return finalMergedTasks;
//   } catch (error) {
//     console.error("Recipe merge failed:", error);
//     // Return original tasks with chimney tasks as fallback
//     return [
//       {
//         id: `fallback_chimney_on_${Date.now()}`,
//         name: "Chimney On",
//         duration: 15,
//         valid: true,
//         category: "Chimney Action",
//         code: "await chimny(1);",
//         cookIn: "np1",
//       },
//       ...tasks.filter(
//         (task) => task.name !== "Chimney On" && task.name !== "Chimney Off"
//       ),
//       {
//         id: `fallback_chimney_off_${Date.now()}`,
//         name: "Chimney Off",
//         duration: 15,
//         valid: true,
//         category: "Chimney Action",
//         code: "await chimny(0);",
//         cookIn: "np1",
//       },
//     ].filter((task) => task?.duration !== undefined);
//   }
// }

export const mergeRecipes = (allTasks) => {
  if (!allTasks || !Array.isArray(allTasks) || allTasks.length === 0) {
    return [];
  }

  console.log("Tasks to merge:", allTasks);

  // Helper function to check if a task is a chimney task
  const isChimneyTask = (task) => {
    return (
      task &&
      (task.name === "Chimney On" ||
        task.name === "Chimney Off" ||
        task.type === "chimney_on" ||
        task.type === "chimney_off" ||
        task.category === "Chimney Action")
    );
  };

  // Filter out all chimney tasks from input tasks to avoid duplicates in middle
  const tasksWithoutChimney = allTasks.filter((task) => !isChimneyTask(task));

  // Split tasks by NutriPot (without chimney tasks)
  const np1Tasks = tasksWithoutChimney.filter((task) => task.cookIn === "np1");
  const np2Tasks = tasksWithoutChimney.filter((task) => task.cookIn === "np2");

  if (np1Tasks.length === 0 && np2Tasks.length === 0) {
    console.log("No valid non-chimney tasks found");
    // Return only chimney tasks if no other tasks exist
    return [
      {
        id: `chimney_on_${Date.now()}`,
        name: "Chimney On",
        duration: 15,
        valid: true,
        complete: 0,
        category: "Chimney Action",
        function: "",
        type: "chimney_on",
        cookIn: "np1",
        level: 1,
        code: "await chimny(1);",
        errorMessage: "",
        isOk: false,
      },
      {
        id: `chimney_off_${Date.now()}`,
        name: "Chimney Off",
        duration: 15,
        valid: true,
        complete: 0,
        category: "Chimney Action",
        function: "",
        type: "chimney_off",
        cookIn: "np1",
        level: 0,
        code: "await chimny(0);",
        errorMessage: "",
        isOk: false,
      },
    ];
  }

  if (np1Tasks.length === 0 || np2Tasks.length === 0) {
    console.log("Only one NutriPot has tasks, no merging needed");
    // Still need to add chimney tasks at start and end
    const finalTasks = [];

    // Add Chimney On at start
    finalTasks.push({
      id: `chimney_on_${Date.now()}`,
      name: "Chimney On",
      duration: 15,
      valid: true,
      complete: 0,
      category: "Chimney Action",
      function: "",
      type: "chimney_on",
      cookIn: "np1",
      level: 1,
      code: "await chimny(1);",
      errorMessage: "",
      isOk: false,
    });

    // Add all non-chimney tasks
    finalTasks.push(...tasksWithoutChimney);

    // Add Chimney Off at end
    finalTasks.push({
      id: `chimney_off_${Date.now()}`,
      name: "Chimney Off",
      duration: 15,
      valid: true,
      complete: 0,
      category: "Chimney Action",
      function: "",
      type: "chimney_off",
      cookIn: "np1",
      level: 0,
      code: "await chimny(0);",
      errorMessage: "",
      isOk: false,
    });

    return finalTasks;
  }

  // Constants
  const IGNORE_WAITING_TIME = WAITING_RECIPE_DURATION; // 5 minutes in seconds - waiting times below this are executed as-is

  // Helper to format waiting durations into human-readable strings
  const formatDuration = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    const parts = [];
    if (mins > 0) parts.push(`${mins} Minute${mins !== 1 ? "s" : ""}`);
    if (secs > 0) parts.push(`${secs} Second${secs !== 1 ? "s" : ""}`);
    return parts.join(" ") || "0 Seconds";
  };

  // Setup task queues and counters
  let np1Queue = [...np1Tasks];
  let np2Queue = [...np2Tasks];
  let np1PendingTasks = [];
  let np2PendingTasks = [];
  let np1WaitingCounter = 0;
  let np2WaitingCounter = 0;
  let currentProcessingNP = "np1"; // Start with np1 by default

  // Result collection
  let mergedTasks = [];

  // Always add chimney on at the beginning
  const chimneyOn = {
    id: `chimney_on_${Date.now()}`,
    name: "Chimney On",
    duration: 15,
    valid: true,
    complete: 0,
    category: "Chimney Action",
    function: "",
    type: "chimney_on",
    cookIn: "np1", // Default to np1
    level: 1,
    code: "await chimny(1);",
    errorMessage: "",
    isOk: false,
  };
  mergedTasks.push(chimneyOn);

  // Process tasks until all queues and waiting counters are empty
  while (
    np1Queue.length > 0 ||
    np2Queue.length > 0 ||
    np1PendingTasks.length > 0 ||
    np2PendingTasks.length > 0 ||
    np1WaitingCounter > 0 ||
    np2WaitingCounter > 0
  ) {
    // If both pots have waiting time, handle the shorter one first
    if (np1WaitingCounter > 0 && np2WaitingCounter > 0) {
      if (np1WaitingCounter <= np2WaitingCounter) {
        // Find the original waiting task
        // eslint-disable-next-line no-loop-func
        const waitingTask = np1Tasks.find(
          (task) =>
            task.category === "Waiting Action" &&
            task.duration >= np1WaitingCounter
        );

        if (waitingTask) {
          const formatted = formatDuration(np1WaitingCounter);
          const adjustedTask = {
            ...waitingTask,
            duration: np1WaitingCounter,
            quantity: np1WaitingCounter,
            args: formatted,
          };
          mergedTasks.push(adjustedTask);
        }

        // Update counters and resume np1 tasks
        np2WaitingCounter -= np1WaitingCounter;
        np1WaitingCounter = 0;
        np1Queue = [...np1PendingTasks];
        np1PendingTasks = [];
        currentProcessingNP = "np1";
      } else {
        // Find the original waiting task
        // eslint-disable-next-line no-loop-func
        const waitingTask = np2Tasks.find(
          (task) =>
            task.category === "Waiting Action" &&
            task.duration >= np2WaitingCounter
        );

        if (waitingTask) {
          const formatted = formatDuration(np2WaitingCounter);
          const adjustedTask = {
            ...waitingTask,
            duration: np2WaitingCounter,
            quantity: np2WaitingCounter,
            args: formatted,
          };
          mergedTasks.push(adjustedTask);
        }

        // Update counters and resume np2 tasks
        np1WaitingCounter -= np2WaitingCounter;
        np2WaitingCounter = 0;
        np2Queue = [...np2PendingTasks];
        np2PendingTasks = [];
        currentProcessingNP = "np2";
      }
      continue;
    }

    // If np1 is waiting, process np2 tasks
    if (np1WaitingCounter > 0) {
      if (np2Queue.length > 0 || np2PendingTasks.length > 0) {
        // Get next task from np2
        const taskQueue = np2Queue.length > 0 ? np2Queue : np2PendingTasks;
        const pendingTasks = np2Queue.length > 0 ? np2PendingTasks : [];

        const nextTask = taskQueue.shift();

        if (
          nextTask.category === "Waiting Action" &&
          nextTask.duration > IGNORE_WAITING_TIME
        ) {
          // Long waiting task - start np2 waiting counter
          np2WaitingCounter = nextTask.duration;
          pendingTasks.push(...taskQueue);
          np2Queue = [];
          np2PendingTasks = pendingTasks;

          // Decrease np1 counter by the duration of this task
          np1WaitingCounter = Math.max(
            0,
            np1WaitingCounter - nextTask.duration
          );

          if (np1WaitingCounter === 0) {
            // Resume np1 tasks if counter reached zero
            np1Queue = [...np1PendingTasks];
            np1PendingTasks = [];
            currentProcessingNP = "np1";
          }
        } else {
          // Regular task or short waiting task - add to merged tasks
          // Skip chimney tasks as they are already filtered out
          if (!isChimneyTask(nextTask)) {
            mergedTasks.push(nextTask);
          }

          // Update queue pointers
          if (np2Queue.length > 0) np2Queue = taskQueue;
          else np2PendingTasks = taskQueue;

          // Decrease np1 waiting counter by this task's duration
          const taskDuration = nextTask.duration || 0;
          np1WaitingCounter = Math.max(0, np1WaitingCounter - taskDuration);

          if (np1WaitingCounter === 0) {
            // Resume np1 tasks if counter reached zero
            np1Queue = [...np1PendingTasks];
            np1PendingTasks = [];
            currentProcessingNP = "np1";
          }
        }
      } else {
        // No more np2 tasks, resume np1
        // eslint-disable-next-line no-loop-func
        const waitingTask = np1Tasks.find(
          (task) =>
            task.category === "Waiting Action" &&
            task.duration >= np1WaitingCounter
        );

        if (waitingTask && np1WaitingCounter > 0) {
          const formatted = formatDuration(np1WaitingCounter);
          const adjustedTask = {
            ...waitingTask,
            duration: np1WaitingCounter,
            quantity: np1WaitingCounter,
            args: formatted,
          };
          mergedTasks.push(adjustedTask);
        }

        np1WaitingCounter = 0;
        np1Queue = [...np1PendingTasks];
        np1PendingTasks = [];
        currentProcessingNP = "np1";
      }
      continue;
    }

    // If np2 is waiting, process np1 tasks
    if (np2WaitingCounter > 0) {
      if (np1Queue.length > 0 || np1PendingTasks.length > 0) {
        // Get next task from np1
        const taskQueue = np1Queue.length > 0 ? np1Queue : np1PendingTasks;
        const pendingTasks = np1Queue.length > 0 ? np1PendingTasks : [];

        const nextTask = taskQueue.shift();

        if (
          nextTask.category === "Waiting Action" &&
          nextTask.duration > IGNORE_WAITING_TIME
        ) {
          // Long waiting task - start np1 waiting counter
          np1WaitingCounter = nextTask.duration;
          pendingTasks.push(...taskQueue);
          np1Queue = [];
          np1PendingTasks = pendingTasks;

          // Decrease np2 counter by the duration of this task
          np2WaitingCounter = Math.max(
            0,
            np2WaitingCounter - nextTask.duration
          );

          if (np2WaitingCounter === 0) {
            // Resume np2 tasks if counter reached zero
            np2Queue = [...np2PendingTasks];
            np2PendingTasks = [];
            currentProcessingNP = "np2";
          }
        } else {
          // Regular task or short waiting task - add to merged tasks
          // Skip chimney tasks as they are already filtered out
          if (!isChimneyTask(nextTask)) {
            mergedTasks.push(nextTask);
          }

          // Update queue pointers
          if (np1Queue.length > 0) np1Queue = taskQueue;
          else np1PendingTasks = taskQueue;

          // Decrease np2 waiting counter by this task's duration
          const taskDuration = nextTask.duration || 0;
          np2WaitingCounter = Math.max(0, np2WaitingCounter - taskDuration);

          if (np2WaitingCounter === 0) {
            // Resume np2 tasks if counter reached zero
            np2Queue = [...np2PendingTasks];
            np2PendingTasks = [];
            currentProcessingNP = "np2";
          }
        }
      } else {
        // No more np1 tasks, resume np2
        // eslint-disable-next-line no-loop-func
        const waitingTask = np2Tasks.find(
          (task) =>
            task.category === "Waiting Action" &&
            task.duration >= np2WaitingCounter
        );

        if (waitingTask && np2WaitingCounter > 0) {
          const formatted = formatDuration(np2WaitingCounter);
          const adjustedTask = {
            ...waitingTask,
            duration: np2WaitingCounter,
            quantity: np2WaitingCounter,
            args: formatted,
          };
          mergedTasks.push(adjustedTask);
        }

        np2WaitingCounter = 0;
        np2Queue = [...np2PendingTasks];
        np2PendingTasks = [];
        currentProcessingNP = "np2";
      }
      continue;
    }

    // No waiting time - process tasks from current pot
    if (currentProcessingNP === "np1" && np1Queue.length > 0) {
      const nextTask = np1Queue.shift();

      if (
        nextTask.category === "Waiting Action" &&
        nextTask.duration > IGNORE_WAITING_TIME
      ) {
        // Long waiting task - start np1 waiting counter and switch to np2
        np1WaitingCounter = nextTask.duration;
        np1PendingTasks = [...np1Queue];
        np1Queue = [];
        currentProcessingNP = "np2";
      } else {
        // Regular task or short waiting task - add to merged tasks
        // Skip chimney tasks as they are already filtered out
        if (!isChimneyTask(nextTask)) {
          mergedTasks.push(nextTask);
        }
      }
    } else if (currentProcessingNP === "np2" && np2Queue.length > 0) {
      const nextTask = np2Queue.shift();

      if (
        nextTask.category === "Waiting Action" &&
        nextTask.duration > IGNORE_WAITING_TIME
      ) {
        // Long waiting task - start np2 waiting counter and switch to np1
        np2WaitingCounter = nextTask.duration;
        np2PendingTasks = [...np2Queue];
        np2Queue = [];
        currentProcessingNP = "np1";
      } else {
        // Regular task or short waiting task - add to merged tasks
        // Skip chimney tasks as they are already filtered out
        if (!isChimneyTask(nextTask)) {
          mergedTasks.push(nextTask);
        }
      }
    } else {
      // Switch to the other pot or check if we need to move pending tasks back
      if (currentProcessingNP === "np1") {
        if (np2Queue.length > 0) {
          currentProcessingNP = "np2";
        } else if (np1PendingTasks.length > 0) {
          np1Queue = [...np1PendingTasks];
          np1PendingTasks = [];
        } else if (np2PendingTasks.length > 0) {
          np2Queue = [...np2PendingTasks];
          np2PendingTasks = [];
          currentProcessingNP = "np2";
        } else {
          break; // No more tasks
        }
      } else {
        // currentProcessingNP === "np2"
        if (np1Queue.length > 0) {
          currentProcessingNP = "np1";
        } else if (np2PendingTasks.length > 0) {
          np2Queue = [...np2PendingTasks];
          np2PendingTasks = [];
        } else if (np1PendingTasks.length > 0) {
          np1Queue = [...np1PendingTasks];
          np1PendingTasks = [];
          currentProcessingNP = "np1";
        } else {
          break; // No more tasks
        }
      }
    }
  }

  // Always add chimney off at the end
  const chimneyOff = {
    id: `chimney_off_${Date.now()}`,
    name: "Chimney Off",
    duration: 15,
    valid: true,
    complete: 0,
    category: "Chimney Action",
    function: "",
    type: "chimney_off",
    cookIn: "np1", // Default to np1
    level: 0,
    code: "await chimny(0);",
    errorMessage: "",
    isOk: false,
  };
  mergedTasks.push(chimneyOff);

  // Filter out any undefined tasks and ensure no duplicate chimney tasks in middle
  mergedTasks = mergedTasks.filter((task) => task !== undefined);

  // Final safety check - remove any chimney tasks that are not at start or end positions
  const finalTasks = [];
  mergedTasks.forEach((task, index) => {
    const isFirst = index === 0;
    const isLast = index === mergedTasks.length - 1;
    const isChimney = isChimneyTask(task);

    if (isChimney) {
      // Only keep chimney tasks if they are at start (Chimney On) or end (Chimney Off)
      if (
        (isFirst && task.name === "Chimney On") ||
        (isLast && task.name === "Chimney Off")
      ) {
        finalTasks.push(task);
      }
      // Skip chimney tasks in the middle
    } else {
      // Keep all non-chimney tasks
      finalTasks.push(task);
    }
  });

  console.log("Interleaved merged tasks:", finalTasks);
  return finalTasks;
};

export default mergeRecipes;
